import { call, put, takeEvery } from 'redux-saga/effects';
import { setCustomerValuation } from '../../requests/set_customer_valuation_request';
import { getLeadProfileHistory, getLeadProfileWithStatus } from '../../requests/get_lead_profile_request';
import { SET_LEADS_CUSTOMER_VALUATION_REQUEST } from '../constants/set_customer_valuation.constants';
import { setLeadsCustomerValuationRequestSuccess, setLeadsCustomerValuationRequestFailure } from '../actions/set_customer_valuation.actions';
import { message_success, message_error } from '../../../../../components/Message';
import { changeLeadsStatusRequestSuccess } from '../actions/change_lead_status.actions';

function* setLeadsCustomerValuationRequest({
    lead_id, customer_valuation, selling_reason, customer_valuation_by, close_reason,
}) {
    const { result, options, error } = yield call(setCustomerValuation, lead_id, customer_valuation, selling_reason, customer_valuation_by, close_reason);
    if (result) {
        const current_status = yield call(getLeadProfileWithStatus, lead_id);
        if (current_status.result) {
            yield put(setLeadsCustomerValuationRequestSuccess(options.customer_valuation, selling_reason, customer_valuation_by, new Date(), close_reason));
            yield put(changeLeadsStatusRequestSuccess(current_status.options));
            // const history = yield call(getLeadProfileHistory, lead_id);
            // history.result ?
            //   yield put(changeLeadHistoryRequestSuccess(history.options.history)) :
            //   yield put(changeLeadHistoryRequestFailure(history.error));
            message_success('Customer Valuation Added Successfully!');
        }
    } else {
        yield put(setLeadsCustomerValuationRequestFailure(error));
        message_error('Something gone wrong!');
    }
}

export default function* setLeadsCustomerValuationSaga() {
    yield takeEvery(SET_LEADS_CUSTOMER_VALUATION_REQUEST, setLeadsCustomerValuationRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/set_leads_customer_valuation.saga.js